import React from 'react';
import Loading from '~/Components/Loading';
import GridIntVendas from './GridIntVendas';
import GridDocumentos from './GridDocumentos';
import GridRepasse from './GridRepasse';
import GridBoleto from './GridBoleto';
import GridPDV from './GridPDV';

const TabIntegracao = ({ codigoFamilia, dados, permissoes, onRecarregar }) => {
  if (dados == null) return <Loading />;

  return (
    <div>
      {permissoes.imobiliaria && (
        <GridIntVendas
          codigoFamilia={codigoFamilia}
          intVendas={dados.int_vendas != null ? dados.int_vendas : []}
          onRecarregar={onRecarregar}
        />
      )}
      {permissoes.comercial && (
        <GridDocumentos
          codigoFamilia={codigoFamilia}
          documentos={dados.documentos != null ? dados.documentos : []}
          onRecarregar={onRecarregar}
        />
      )}
      {permissoes.repasse && (
        <GridRepasse
          codigoFamilia={codigoFamilia}
          repasses={dados.repasses != null ? dados.repasses : []}
          onRecarregar={onRecarregar}
        />
      )}
      {permissoes.boleto && (
        <GridBoleto
          codigoFamilia={codigoFamilia}
          boletos={dados.boletos != null ? dados.boletos : []}
          onRecarregar={onRecarregar}
        />
      )}
      <GridPDV
        codigoFamilia={codigoFamilia}
        pdv={dados.pdv != null ? dados.pdv : []}
        permissoes={permissoes}
        onRecarregar={onRecarregar}
      />
    </div>
  );
};

export default TabIntegracao;
